module.exports = __webpack_public_path__ + "img/18.52e8c5c4.png";